import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW1500Model } from "../kymw1500.model";
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * マーク変換情報更新サービス
 * @export UpdateCwsMarkConvService
 * @class UpdateCwsMarkConvService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class UpdateCwsMarkConvService extends PlessJsonResponderSub<any> {
  model: KYMW1500Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateCwsMarkConvService
   */
  private getBody(): PlessRequest {
    const combinationList: {
      parameter: {
        IconCode: string,
        IconCodeBranch: string,
        MarkConv: string
      }
    }[] = [];

    for (const item of this.model.markConvInfoListForView) {
      const index = combinationList.findIndex(data =>
        data.parameter.IconCode === item.iconCode &&
        data.parameter.IconCodeBranch === item.iconCodeBranch
      );
      if (index === -1) {
        combinationList.push({
          parameter: {
            IconCode: item.iconCode,
            IconCodeBranch: item.iconCodeBranch,
            MarkConv: item.markFileName
          }
        });
      } else {
        combinationList[index].parameter.MarkConv += (',\n' + item.markFileName);
      }
    }

    return new PlessRequest({
      update: [
        {
          IconInfoList: {
            combination: combinationList
          }
        }
      ]
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof UpdateCwsMarkConvService
   */
  execute(model: KYMW1500Model, f: () => void = null): void {
    this.model = model;
    this.calbak = f;
    this.send('updateCwsMarkConv', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof UpdateCwsMarkConvService
   */
  success() {
    if (this.calbak) this.calbak();
  }

  /**
   * 業務エラー時のメソッド
   * @param errList サーバ受信データ
   * 機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public plessErrorHandler(errList: Object): void {
    super.plessErrorHandler(errList);
  }

  /**
   * 特殊なエラーが返ってきた場合に呼び出されるメソッド。<br/>
   * 機能独自のステータスコードを持つ場合、このメソッドをオーバーライドして処理を実装する。
   */
  public exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
